module.exports = __webpack_public_path__ + "static/img/get_en.a7eb7ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home_model/get_en.png
// module id = HQgJ
// module chunks = 88